/* eslint no-console: "off",  */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@cx/ui/Button';
import Alert from '@cx/ui/Alert';
import Modal from 'react-bootstrap/lib/Modal';
import './vehicleList.page.scss';

import ErrorBoundary from '../errors/errorBoundary.component';
import VehicleFiltersComponent from './filters/vehicleFilters.component';
import VehicleListComponent from './list/vehicleList.component';
import VehicleDetailComponent from './detail/vehicleDetail.component';
import { FiltersMap } from './filters.model';
import { CarMap } from './car.model';
import { InventoryService } from './inventory.service';

class VehicleListPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vehicles: [],
      filters: null,
      selectedVehicleId: this.emptyVehicleId,
      selectedVehicle: null,
      currentPage: 1,
      alertVisible: !!this.props.match.params.alert,
      environment: window.genesisSettings.appEnvironment
    };

    this.onFilter = this.onFilter.bind(this);
    this.handleAlertDismiss = this.handleAlertDismiss.bind(this);

    this.inventoryService = new InventoryService(this.accessToken, this.entityId);
    this.filtersMap = new FiltersMap();
  }

  componentDidMount() {
    this.inventoryService.getVehicleFilters().then(response => {
      const data = response;
      this.filtersMap.map(data).then(x => {
        this.setState({ filters: x });
      });
    });

    this.databind();
  }

  emptyVehicleId = '00000000-0000-0000-0000-000000000000';
  pageSize = 20;

  databind = () => {
    const query = this.inventoryService.getQuery(this.pageSize, this.state.currentPage, this.state.filters);

    this.inventoryService.getVehicles(query, true).then(response => {
      const data = new CarMap().map(response.items);
      this.setState({ vehicles: data });
    });
  };

  onVehicleSelected = id => {
    const v = this.state.vehicles.find(x => x.id === id);
    this.setState({
      selectedVehicle: v,
      selectedVehicleId: v.id
    });
  };

  onFilter(filters) {
    this.setState(
      {
        currentPage: 1,
        selectedVehicle: null,
        selectedVehicleId: this.emptyVehicleId,
        filters
      },
      () => {
        this.databind();
      }
    );
  }

  onPageChanged = pageDirection => {
    console.log(this.state.currentPage);
    let nextPage = this.state.currentPage;
    if (pageDirection === 'next') {
      nextPage = this.state.currentPage + this.pageSize;
    } else {
      const p = this.state.currentPage - this.pageSize;
      nextPage = p <= 1 ? 1 : p;
    }

    this.setState({ currentPage: nextPage }, () => this.databind());
  };

  // Ported code from FakeListPage
  get accessToken() {
    return this.props.accessToken;
  }
  get entityId() {
    return this.props.match.params.entityId;
  }

  get message() {
    if (this.props.location && this.props.location.state) {
      return this.props.location.state.messageText;
    }
    return '';
  }

  get history() {
    return this.props.history;
  }

  handleAlertDismiss() {
    const entityId = this.entityId;
    this.history.push(`/better-fake-vlp/${entityId}`);
    this.setState({ alertVisible: false });
  }

  // Add Vehicle jazz
  redirectToVdp = id => {
    const entityId = this.entityId;
    this.history.push(`/better-fake-vdp/${entityId}/${id}`);
  };

  get showModal() {
    return !!this.state.widgetEditorVisible;
  }

  openVinceEdit = (widget, editing) => {
    this.setState({
      widgetEditorVisible: widget,
      widgetEditorEditing: editing
    });
  };

  onWidgetEditorEnter = () => {
    const self = this,
      vinceEditor = document.getElementById('vince-editor');

    vinceEditor.classList.add('vince-embed');
    vinceEditor.dataset.path = 'add-vehicle';
    vinceEditor.dataset.entityId = self.entityId;
    vinceEditor.dataset.accessToken = self.props.accessToken;

    VINCE.init([vinceEditor]);
    VINCE.addEventListener(vinceEditor, 'vehicleCreated', function(event) {
      console.log(event);

      if (event.message.close) {
        self.setState(
          {
            widgetEditorVisible: undefined
          },
          () => {
            self.redirectToVdp(event.message.id);
          }
        );
      }
    });

    VINCE.addEventListener(vinceEditor, 'vehicleCreateExist', function(event) {
      console.log(event);

      if (event.message.close) {
        self.setState(
          {
            widgetEditorVisible: undefined
          },
          () => {
            self.redirectToVdp(event.message.id);
          }
        );
      }
    });

    VINCE.addEventListener(vinceEditor, 'vehicleRecovered', function(event) {
      console.log(event);

      self.setState(
        {
          widgetEditorVisible: undefined
        },
        () => {
          self.redirectToVdp(event.message.id);
        }
      );
    });

    VINCE.addEventListener(vinceEditor, 'vehicleTransferFailed', function(event) {
      console.log(event);

      self.setState({
        widgetEditorVisible: undefined
      });
    });

    VINCE.addEventListener(vinceEditor, 'vehicleRecoveredFailed', function(event) {
      console.log(event);
    });

    VINCE.addEventListener(vinceEditor, 'vehicleTransferDealerChanged', function(event) {
      console.log(event);
    });

    VINCE.addEventListener(vinceEditor, 'vehicleCreateFailed', function(event) {
      console.log(event);
      self.setState({
        widgetEditorVisible: undefined
      });
    });

    VINCE.addEventListener(vinceEditor, 'vehicleCancelEdit', function(event) {
      console.log(event);

      if (event.message.close || !event.message.dirty) {
        self.setState({
          widgetEditorVisible: undefined
        });

        vinceEditor.scrollIntoView();
        console.log(`The following fields were dirty: ${event.message.dirtyFieldPaths}`);
      }
    });
  };

  onWidgetEditorAttemptClose = () => {
    const vinceEditor = document.getElementById('vince-editor');
    if (vinceEditor) {
      VINCE.sendEvent(vinceEditor, 'closeEditor', {});
    }
  };
  // End Add Vehicle jazz

  render() {
    return (
      <div className="vlp">
        <header className="vince-page-header">
          {this.state.alertVisible &&
            this.alertMessage.toUpperCase().includes('ERROR') && (
              <Alert onDismiss={this.handleAlertDismiss} htmlId="dangerAlert" type="danger">
                {this.alertMessage}
              </Alert>
            )}

          {this.state.alertVisible &&
            !this.alertMessage.toUpperCase().includes('ERROR') && (
              <Alert onDismiss={this.handleAlertDismiss} htmlId="successAlert" type="success">
                {this.alertMessage}
              </Alert>
            )}

          <h1>Vehicle list</h1>
          <Button htmlId="vlp-open-add-vehicle" onClick={this.openVinceEdit}>
            Open Add Vehicle
          </Button>
        </header>
        <div className="vlp-container">
          <ErrorBoundary>
            <VehicleFiltersComponent filters={this.state.filters} onFilter={this.onFilter} />
            <VehicleListComponent vehicles={this.state.vehicles} selectedVehicleId={this.state.selectedVehicleId} onRowSelection={this.onVehicleSelected} onPageChanged={this.onPageChanged} currentPage={this.state.currentPage} pageSize={this.pageSize} />
            <VehicleDetailComponent key={this.state.selectedVehicleId} car={this.state.selectedVehicle} entityId={this.entityId} />
          </ErrorBoundary>
        </div>
        <Modal show={this.showModal} container={this} onHide={this.onWidgetEditorAttemptClose} onEnter={this.onWidgetEditorEnter} bsSize="large">
          <div id="vince-editor" data-auto-resize="true" />
        </Modal>
      </div>
    );
  }
}

VehicleListPage.propTypes = {
  accessToken: PropTypes.string,
  history: PropTypes.object.isRequired,
  location: PropTypes.object,
  match: PropTypes.object
};

export default VehicleListPage;



// WEBPACK FOOTER //
// ./src/components/vehicles/vehicleList.page.js